module.exports = __webpack_public_path__ + "media/icon/arrow-drop-down-aa46ebb1.svg";